import React, { useState } from 'react'
import { Badge, Input } from 'reactstrap'

export const ExcludedEditor = (props) => {

    const {
        onUpdate,
        forceUpdate,
        row
    } = props;

    const initValue = row.excludedFromAgreement;

    const [saving, setSaving] = useState(false);
    const [currentValue, setCurrentValue] = useState(row.excludedFromAgreement);

    const handleClick = () => {
        if (!saving && currentValue !== initValue) {
          setSaving(true);
            console.log(row);

            //If we are INCLUDING a user, we will clear all Excluded Additions.
            if (currentValue == false) {
                onUpdate({
                    selectedValue: null,
                    selectedOption: row.ignoreReason,
                    selectedDate: undefined,
                    excluded: currentValue,
                });
            } else {
                onUpdate({
                    selectedValue: row.selectedExcludedAdditions,
                    selectedOption: row.ignoreReason,
                    selectedDate: undefined,
                    excluded: currentValue,
                });
            }

         
          setSaving(false);
        }
        forceUpdate();
    }

    const handleValueChange = (ev) => {
        setCurrentValue(ev.target.checked);
    }

    return (
        <>
            <Input
                autoComplete="off"
                checked={currentValue}
                type="checkbox"
                id={`excluded-${row.id}`}
                onChange={handleValueChange}
                style={{ marginLeft: "0px", marginTop: "7px" }}
            />

            <Badge
                style={{
                    float: 'right',
                    marginRight: '20px',
                    marginTop: '3px',
                }}
                color="secondary"
                onClick={handleClick} >

                { currentValue === initValue ? "close" : saving ? "saving" : "save" }
            </Badge>
        </>
    )
}